import { z } from "zod/mini"

import { ImageLegacyViewSchema, ImageLegacySchema } from "./legacy/image"

export const ImageContentType = "ImageContent" as const

export const ImageContentViewSchema = ImageLegacyViewSchema

export type ImageContentView = z.infer<typeof ImageLegacyViewSchema>

export const ImageContentSchema = z.extend(ImageLegacySchema, {
	__TYPE__: z.literal(ImageContentType),
})

export type ImageContent = z.infer<typeof ImageContentSchema>
